export default __webpack_public_path__ + "static/media/FLAME1.96fbb304.jpg";